import axiosClient from "./axiosClient";

export async function getHomeFeed(take = 10) {
  const response = await axiosClient.get("/Recommendations/home", { params: { take } });
  return response.data;
}
